import {SentryAsync} from "./SentryAsync";


let sentryAsync: SentryAsync;
export const getSentry = async (): Promise<SentryAsync> => {
    if (!sentryAsync) {
        sentryAsync = new SentryAsync();
        await sentryAsync.init();
    }
    return sentryAsync;
}
